import React, { useState, useEffect } from "react";
import { useForm, ValidationError } from '@formspree/react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

function ContactForm() {
  const [state, handleSubmit] = useForm("xzzroarv");
  const { t } = useTranslation('contact');
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const defaultMessage = queryParams.get('message') || '';
  const defaultSubject = queryParams.get('subject') || '';

  const [message, setMessage] = useState(defaultMessage);
  const [subject, setSubject] = useState(defaultSubject);

  if (state.succeeded) {
    return (
      <section className="tc-contact-form-style1 mt-10">
        <div className="container text-center">
          <h3 className="text-success">{t('form.successTitle')}</h3>
          <p className="fsz-16 mt-10">{t('form.successMessage')}</p>
        </div>
      </section>
    );
  }

  return (
    <section className="tc-contact-form-style1 mt-10">
      <div className="container">
        <div className="row justify-content-between">
          <div className="col-lg-4">
            <div className="info wow fadeInUp slow" data-wow-delay="0.2s">
              <h3 className="fsz-45 fw-500 mb-80">{t('form.title')}</h3>
              <p className="fsz-18 color-black mt-15">
                <a href="mailto:sales@botanicheska.com">
                  sales@botanicheska.com
                </a>
              </p>
               <p className="fsz-18 color-black mt-15">
                <a href="tel:+359893366406">
                  +359 893366406
                </a>
              </p>
            </div>
          </div>
          <div className="col-lg-6">
            <form onSubmit={handleSubmit} className="form mt-5 mt-lg-0 wow fadeInUp slow" data-wow-delay="0.4s">
              <div className="row">
                <div className="col-lg-6">
                  <div className="form-group mb-30">
                    <label htmlFor="name">
                      {t('form.fields.name')} <span className="color-orange1">{t('form.required')}</span>
                    </label>
                    <input
                      id="name"
                      type="text"
                      name="name"
                      className="form-control"
                      placeholder={t('form.placeholders.name')}
                      required
                    />
                    <ValidationError prefix="Име" field="name" errors={state.errors} />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group mb-30">
                    <label htmlFor="email">
                      {t('form.fields.email')} <span className="color-orange1">{t('form.required')}</span>
                    </label>
                    <input
                      id="email"
                      type="email"
                      name="email"
                      className="form-control"
                      placeholder={t('form.placeholders.email')}
                      required
                    />
                    <ValidationError prefix="Имейл" field="email" errors={state.errors} />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group mb-30">
                    <label htmlFor="phone">
                      {t('form.fields.phone')} <span className="color-orange1">{t('form.required')}</span>
                    </label>
                    <input
                      id="phone"
                      type="text"
                      name="phone"
                      className="form-control"
                      placeholder={t('form.placeholders.phone')}
                      required
                    />
                    <ValidationError prefix="Телефон" field="phone" errors={state.errors} />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group mb-30">
                    <label htmlFor="subject">
                      {t('form.fields.subject')} <span className="color-orange1">{t('form.required')}</span>
                    </label>
                    <select
                      id="subject"
                      name="subject"
                      className="form-select form-control"
                      value={subject}
                      onChange={(e) => setSubject(e.target.value)}
                      required
                    >
                      <option value="">{t('form.placeholders.subject')}</option>
                      <option value="apartments">{t('form.subjects.apartments')}</option>
                      <option value="parking">{t('form.subjects.parking')}</option>
                      <option value="commercial">{t('form.subjects.commercial')}</option>
                      <option value="other">{t('form.subjects.other')}</option>
                    </select>
                    <ValidationError prefix="Повод" field="subject" errors={state.errors} />
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="form-group mb-30">
                    <label htmlFor="message">{t('form.fields.message')}</label>
                    <textarea
                      id="message"
                      name="message"
                      rows="6"
                      placeholder={t('form.placeholders.message')}
                      className="form-control"
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                      required
                    ></textarea>
                    <ValidationError prefix="Съобщение" field="message" errors={state.errors} />
                  </div>
                </div>
              </div>
              <button type="submit" disabled={state.submitting} className="butn border rounded-pill mt-10 hover-bg-white">
                <span>
                  {t('form.submitButton')}
                  <i className="small ms-1 ti-arrow-top-right"></i>
                </span>
              </button>
              <p className="fsz-12 color-666 mt-20">
                {t('form.terms')}
                <a
                  href="/innerpages/terms"
                  className="color-000 text-decoration-underline ms-1"
                >
                  {t('form.termsLink')}
                </a>
              </p>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactForm;
